module.exports = __webpack_public_path__ + "static/media/manifold_entry_direction.dfd2e32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/manifold_entry_direction.png
// module id = 894
// module chunks = 0